module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "book-author"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-text",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "pro"
    }
  }, [_c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/prologue"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_001"
    }
  }, [_vm._v("1. Hunting Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Great Expectations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indent",
    attrs: {
      "id": "ch2a"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_002a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("France 1788")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A Prick of Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The New World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indent",
    attrs: {
      "id": "ch4a"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_004a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Venice 1847")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Fantastic Aerialists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. A Beating Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Island of Doctor Wells")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indent",
    attrs: {
      "id": "ch7a"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_007a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Orleans 1916")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Story of A")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. A Game of Two Halves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indent",
    attrs: {
      "id": "ch9a"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_009a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Zealand 1964")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. A Congregation of Pleasure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter_011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Illustrated Woman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-space-after",
    attrs: {
      "id": "epi"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text",
    attrs: {
      "id": "abt"
    }
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/about_author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0